<template>
    <div class="basicformation">
        <div class="title">基础信息</div>
        <div class="content">
            <el-row class="row-bg">
                <div v-for="(item,index) in dataList" :key="index">
                    <el-col class="flex" :span="Number(item.width)"  v-if="item.type !== 'formHeader' && item.visible">
                        <div class="grid-content">{{item.title}}：</div>
                        <div class="bg-purple">{{stateType(basicInf[item.field],item.field)}}</div>
                    </el-col>
                </div>
            </el-row>
        </div>
    </div>
</template>
<script>
import {mdmdictdata,mdmtableconfigForm,mdmRegionController} from "@/api/api"; 
// import { Storage } from "@/utils/storage";
export default {
    name:'basicformation',
    props: ["basicInf"],
    data(){
        return{
            dataList:[],
            selectValList:[],
            provinceCode:'',//省code
            cityCode:'', //市code
            provinceCodeData:[], //省
            cityCodeData:[], //市
            districtCodeData:[], //区
        }
    },
    created(){
        this.infoList();
        // 从传递得数据得到  暂时不做，没有正确对应得code
        // this.mdmRegionControllers(1);
        // this.mdmRegionControllers(2,this.basicInf.provinceCode)
        // this.mdmRegionControllers(3,this.basicInf.cityCode)
    },
    mounted(){
        // 查询数据字典
        this.mdmdictdatas();
    },
    methods:{
        /**
         * @description:基础信息   
         * @param {*} functionCode 固定参数
         * @param {*} parentCode   固定参数
         * @author: txp
         */    
        infoList(){
            mdmtableconfigForm({
                functionCode: "dms_contract_base_info",
                parentCode: "CRM20210219000000945"
            }).then(res=>{
                this.dataList = res.result
            })
            .catch(error=>{
                this.$message.error(error)
            })
        },
        // 获取合同类型,查询数字字典
       async mdmdictdatas(){
           await mdmdictdata({
                dictTypeCode:'contract_type'
            }).then(res=>{
                this.selectValList = res.result
            })
            .catch(error=>{
                this.$message.error(error)
            })
        },
        /**
         * @description:  通过获取到基础信息后其中合同类型，以及省市区需要请求数据字典进行判断类型，通过筛选后返回具体得值
         * @param {*} value 获取得信息得具体值，type类型  
         * @param {*} contractType  //判断合同类型
         * @param {*}  provinceCode  省
         * @param {*}  cityCode  市
         * @param {*}  districtCode  区
         * @return {*}
         * @author: txp
         */
        stateType(value,type){
            let _this = this
            // 筛选合同类型
            if(type == 'contractType'){
                try{
                    let listValue = _this.selectValList.find(item=>{
                    if(item.dictCode == value){
                        return item.dictValue
                    }
                })
                     return listValue.dictValue
                }
                catch{}
            }
            // 筛选省
            // else if(type == 'provinceCode'){  
            //     _this.provinceCode = value;
            //     try{
            //         let listValue = _this.provinceCodeData.find(item=>{
            //         if(item.regionCode == value){
            //             return item.regionName
            //         }
            //     })
            //          return listValue.regionName
            //     }
            //     catch{}
            // }
            // // 筛选市
            // else if(type == 'cityCode'){  //市
            //     _this.cityCode = value
            //     _this.mdmRegionControllers(2,_this.provinceCode)
            // }
            // // 筛选区
            // else if(type == 'districtCode'){  //区
            // _this.mdmRegionControllers(3,_this.cityCode)
            // }
            // 其他值
            else{
                return value
            }
        },
        /**
         * @description: 查看省市区
         * @param {*}  regionLevel  1省 2市 3.区
         * @param {*}  parentCode  省只传一个参数，市区则需要传对应的code
         * @return {*} 
         * @author: txp
         */
       mdmRegionControllers(regionLevel,parentCode = ''){
           mdmRegionController({
                regionLevel,
                parentCode
            }).then(res=>{
                if(regionLevel == 1){
                    this.provinceCodeData = res.result //省
                    console.log(this.provinceCodeData,"查看")
                }else if(regionLevel == 2){
                    this.cityCodeData = res.result //市
                }else{
                    this.districtCodeData = res.result //区
                }
            }).catch(error=>{
                this.$message.error(error)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .basicformation{
        margin: 20px 0px;
        border-bottom: 1px solid $color-primary;
        .title{
            font-size: 18px;
            font-weight: 600;
            border-left: 9px solid $color-primary;
            padding-left: 9px;
            height: 18px;
            line-height: 18px;
        }
        .content{
            padding: 20px;
            /deep/.el-row {
                .el-col{
                    border-radius: 4px;
                    line-height: 30px;
                    margin-top: 10px;
                }
                .grid-content{
                    width: 130px;
                    text-align: right;
                    padding-right: 10px;
                    box-sizing: border-box;
                    font-size: 13px;
                    color: #666666;
                }
                .bg-purple{
                    line-height: 30px;
                    font-size: 13px;
                    color: #666666;
                    background: #eee;
                    padding: 0 10px;
                    min-height: 30px;
                    flex: 1;
                    border-radius: 6px
                }
                .remarks{
                    min-height: 80px;
                }
            }
        }
    }
</style>
